/*
 * @Author: Jerman
 * @Date: 2020-01-07 17:08:42
 * @LastEditors  : Jerman
 * @LastEditTime : 2020-01-08 18:07:41
 * @Description: -
 */
import JSEncrypt from 'encryptlong';

const Encrypt = new JSEncrypt();

let publicKey = '';
publicKey += '-----BEGIN PUBLIC KEY-----';
publicKey += 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDcCZX2nFwH3A2Gq1n6q73TdDjg';
publicKey += '7WxWyJ9VYU0nYSeHjcI/68cQ4fglZ1/eKn4ZyFJsRGMLn2CEfQi8UxsRqxrHO8K2';
publicKey += 'Rp6uM0Uoykp1d8ts5eL3B4iwWKsjXaClhReijJBLpaIZHuJNi6u4B4YWDeas4s0m';
publicKey += 'hiLqz0GBEYL6ImMKnQIDAQAB';
publicKey += '-----END PUBLIC KEY-----';

export default {
  /**
   * 加密一个参数
   * @param {*} value 需要加密的值
   */
  encrypt(value) {
    Encrypt.setPublicKey(publicKey);
    return Encrypt.encryptLong(value);
  },
};
